const api = require('./config.json');
export const API_URL = api.api_url;

// logando usuario
export function TOKEN_POST(body) {
  return {
    url: API_URL + '/login',
    options: {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
    },
  };
}

// Buscando todos os Usuarios
export function USERS_GET(token) {
  return {
    url: API_URL + '/user',
    options: {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  };
}
// Buscando todos os Usuarios
export function USERS_GET_FILTER(token, filter) {
  return {
    url: API_URL + `/user/find/${filter}`,
    options: {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  };
}

export function USERS_GET_PAGE(token, pageNumber) {
  return {
    url: API_URL + `/user?page=${pageNumber}`,
    options: {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  };
}


// Buscando um único usuário
export function USER_GET(id, token) {
  return {
    url: API_URL + `/user/${id}`,
    options: {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  };
}

// cadastrando novo usuario
export function USER_POST(body, token) {
  return {
    url: API_URL + "/user",
    options: {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Bearer " + token
      },
      body: JSON.stringify(body),
    },
  };
}

export function USER_PUT(id, body, token) {
 return {
   url: API_URL + `/user`,
   options: {
     method: "POST",
     headers: {
       "Content-Type": "application/json",
       Authorization: "Bearer " + token
     },
     body: JSON.stringify(body),
   },
 };
}


export function USER_DELETE(id, token) {
  return {
    url: API_URL + `/user/${id}`,
    options: {
      method: "DELETE",
      headers: {
        Authorization: "Bearer " + token
      },
    },
  };
}

// Buscando os tipos de usuário
export function USER_TYPE(token) {
  return {
    url: API_URL + `/usertype`,
    options: {
      method: "GET",
      headers: {
        Authorization: "Bearer " + token,
      },
    },
  };
}
